<template>
  <v-container class="pt-0">
    <v-row v-if="isLoading">
      <v-col cols="12">
        <v-row
          align="center"
          justify="center"
          style="height: 250px;"
        >
          <v-progress-circular
            :size="100"
            :width="5"
            color="primary"
            indeterminate
          />
        </v-row>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" class="pa-0">
        <v-toolbar flat>
          <v-spacer />

          <customer-detail-update-dialog
            :customer="customer"
            @action="onUpdate"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                rounded
                outlined
                color="primary"
                v-on="on"
              >
                <v-icon
                  left
                  small
                >
                  edit
                </v-icon>

                Update details
              </v-btn>
            </template>
          </customer-detail-update-dialog>
        </v-toolbar>
        <v-divider class="" />

      </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <span class="title">Account Information</span>
          <v-divider class="my-3" />

          <info-list
            :list="[
            {
              label: 'Name',
              value: customer.name
            },
            {
              label: 'Email',
              value: customer.email
            },
            {
              label: 'Phone',
              value: customer.phone
            },
            {
              label: 'Description',
              value: customer.description
            },
            {
              label: 'ID',
              value: customer.id
            },
            {
              label: 'Language',
              value: customer.preferred_locales ? customer.preferred_locales.join(', ') : ''
            },
            {
              label: 'Created',
              value: _formatDate(customer.created)
            }

          ]"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <span class="title">Billing Information</span>
          <v-divider class="my-3" />


          <info-list
            :list="[
            {
              label: 'Invoice Prefix',
              value: get(customer, 'invoice_prefix', '')
            },
            {
              label: 'Tax Status',
              value: get(customer, 'tax_exempt', '')
            },
            {
              label: 'Billing Address',
              value: [
                `${get(customer, 'address.line1', '') || ''} ${get(customer, 'address.line2', '') || ''}`,
                `${get(customer, 'address.city', '') || ''} ${get(customer, 'address.state', '') || ''} ${get(customer, 'address.postal_code', '') || ''}`,
                (get(customer, 'address.country', '') || '')
              ]
            },
          ]"
          />
        </v-col>
        <v-col
          cols="12"
          md="4"
        >
          <span class="title">Shipping Information</span>
          <v-divider class="my-3" />

          <info-list
            :list="[
            {
              label: 'Name',
              value: get(customer, 'shipping.name', '')
            },
            {
              label: 'Phone',
              value: get(customer, 'shipping.phone', '')
            },
            {
              label: 'Shipping Address',
              value: [
                `${get(customer, 'shipping.address.line1', '') || ''} ${get(customer, 'shipping.address.line2', '') || ''}`,
                `${get(customer, 'shipping.address.city', '') || ''} ${get(customer, 'shipping.address.state', '') || ''} ${get(customer, 'shipping.address.postal_code', '') || ''}`,
                (get(customer, 'shipping.address.country', '') || '')
              ]
            }
          ]"
          />
        </v-col>


    </v-row>
  </v-container>
</template>
<script>
import { get } from 'lodash'
import { mapActions } from 'vuex'
import { unixToReadableDate , formatDate } from "../../services/util.service"
import CustomerDetailUpdateDialog from "./CustomerDetailUpdateDialog"
import InfoList from "../Common/InfoList"


export default {
  components: { InfoList, CustomerDetailUpdateDialog },
  data() {
    return {
      isLoading: false,
      customer: {}
    }
  },
  async created() {
    const payload = {
      id: this.$route.params.id
    }

    this.isLoading = true
    const customer = await this.getCustomer(payload)
      .finally(() => {
        this.isLoading = false
      })

    this.customer = customer || {}
  },
  methods: {
    ...mapActions([ 'getCustomer' ]),
    get(obj, path, defaultValue) {
      return get(obj, path, defaultValue)
    },
    onUpdate(customer) {
      this.customer = { ...customer }
    },
    _formatDate(timestamp) {
      return formatDate(timestamp)
    }
  },
}
</script>
